import axios from "../AxiosInterCeptor/AxiosInterCeptor";
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";

const URL = process.env.React_App_BaseUrl;

const PostUserConfig = (recData) => {
  return axios.post(`${URL}/saveUserConfig`, recData).then((response) => {
    const res = response.data;
    if (res.error) {
      ToastError(res.message);
    } else {
      ToastSuccess(res.message);
      return res;
    }
  });
};

// Changes by Arun
const UpdateUserConfig = (recData) => {
  return axios.patch(`${URL}/updateUserConfig`, recData).then((response) => {
    const res = response.data;
    if (res.error) {
      ToastError(res.message);
    } else {
      ToastSuccess(res.message);
      return res;
    }
  });
};

// Changes by Arun
const saveCommonConfig = (recData) => {
  return axios.post(`${URL}/saveCommonConfig`, recData).then((response) => {
    const res = response.data;
    if (res.error) {
      ToastError(res.message);
    } else {
      ToastSuccess(res.message);
      return res;
    }
  });
};

// Changes by Arun
const updateCommonConfig = (recData) => {
  return axios.patch(`${URL}/updateCommonConfig`, recData).then((response) => {
    const res = response.data;
    if (res.error) {
      ToastError(res.message);
    } else {
      ToastSuccess(res.message);
      return res;
    }
  });
};

const GetUserConfigByUserId = (_id, data) => {
  // Convert null/undefined to string "undefined" for backend compatibility
  // Check for both null, undefined, and also handle the case where _id might be the string "null"
  let userId;

  // Explicit check for null, undefined, or the string "null"
  if (
    _id === null ||
    _id === undefined ||
    _id === "null" ||
    String(_id).toLowerCase() === "null"
  ) {
    userId = "undefined";
  } else if (_id === "undefined") {
    // If it's already the string "undefined", keep it
    userId = "undefined";
  } else {
    userId = String(_id); // Ensure it's always a string
  }

  console.log(
    "GetUserConfigByUserId - _id (original):",
    _id,
    "type:",
    typeof _id
  );
  console.log(
    "GetUserConfigByUserId - userId (processed):",
    `"${userId}"`,
    "type:",
    typeof userId
  );
  console.log("GetUserConfigByUserId - data:", data);

  // Build headers object - backend expects lowercase header names
  const headers = {
    requesttype: data.requestType,
  };

  // Add optional headers only if they have values
  if (data.companyId) {
    console.log("data.companyId ", data.companyId);
    headers.companyid = data.companyId;
    console.log("headers ", headers);
  }
  if (data.bookingCodeId) {
    headers.bookingcodeid = data.bookingCodeId;
  }
  if (data.subBookingCodeId) {
    headers.subbookingcodeid = data.subBookingCodeId;
  }

  console.log("GetUserConfigByUserId - headers:", headers);
  console.log(
    "GetUserConfigByUserId - URL:",
    `${URL}/getUserConfigByUserId/${userId}`
  );

  return axios
    .get(`${URL}/getUserConfigByUserId/${userId}`, {
      headers: headers,
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const getCommonConfigByUserId = (_id, data) => {
  console.log("data ", data);
  return axios
    .get(`${URL}/getCommonConfigByUserId/${_id}`, {
      headers: {
        requestType: data.requestType,
        companyId: data.companyId,
        bookingCodeId: data.bookingCodeId,
        subBookingCodeId: data.subBookingCodeId,
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const GetRTOLocationByCompanyID = (_id) => {
  return axios
    .get(`${URL}/getRTOLocationByCompanyID/${_id}`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

// Changed by Arun
const disableMultipleUserConfigById = (ids, data) => {
  return axios
    .patch(
      `${URL}/disableMultipleUserConfigById`,
      { ids: ids },
      {
        headers: {
          requesttype: data.requesttype,
          disableDate: data.disableDate,
        },
      }
    )
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    });
};

// Changed by Arun
const disableMultipleCommonConfigById = (ids, data) => {
  return axios
    .patch(
      `${URL}/disableMultipleCommonConfigById`,
      { ids: ids },
      {
        headers: {
          requesttype: data.requesttype,
          disableDate: data.disableDate,
        },
      }
    )
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    });
};

// Changes only the disable date of configs that are already disabled
const updateCommonConfigDisableDate = (ids, disableDate) => {
  return axios
    .patch(`${URL}/updateMultipleCommonConfigDisableDate`, {
      ids: ids,
      disableDate: disableDate.toISOString(),
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    });
};

const DisableUserConfig = (_id, data) => {
  return axios
    .patch(`${URL}/disableUserConfigById/${_id}`, null, {
      headers: {
        requesttype: data.requesttype,
        disableDate: data.disableDate,
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    });
};

const disableCommonConfigById = (_id, data) => {
  return axios
    .patch(`${URL}/disableCommonConfigById/${_id}`, {}, {
      headers: {
        requesttype: data.requesttype,
        disableDate: data.disableDate,
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    });
};

const GetUserConfigById = (_id, data) => {
  return axios
    .get(`${URL}/getUserConfigById/${_id}`, {
      headers: { requestType: data },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const getCommonConfigById = (_id, data) => {
  return axios
    .get(`${URL}/getCommonConfigById/${_id}`, {
      headers: { requestType: data },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const DeleteUserConfig = (_id) => {
  return axios
    .delete(`${URL}/deleteUserConfigById/${_id}`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        ToastError(res.message);
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

// Changed by Arun
const deleteCommonConfigById = (_id) => {
  return axios
    .delete(`${URL}/deleteCommonConfigById/${_id}`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        ToastError(res.message);
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

// Changed by Arun
const DeleteMultipleUserConfigById = (ids) => {
  return axios
    .post(`${URL}/deleteMultipleUserConfigById`, { ids: ids })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    });
};

// Changed by Arun
const deleteMultipleCommonConfigById = (ids) => {
  return axios
    .post(`${URL}/deleteMultipleCommonConfigById`, { ids: ids })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    });
};

const filterRTOLocation = (locations) => {
  const response = [];
  locations.forEach((element) => {
    if (element.disableDate) {
      const currentDate = new Date();
      const disableDateTimestamp = new Date(element.disableDate).setHours(
        24,
        0,
        0,
        0
      );
      const endDate = new Date(disableDateTimestamp);
      if (currentDate <= endDate) {
        console.log("currentDate :", currentDate, " endDate: ", endDate);
        response.push(element);
      }
    } else {
      response.push(element);
    }
  });
  return response;
};

export {
  PostUserConfig,
  GetUserConfigByUserId,
  getCommonConfigByUserId,
  UpdateUserConfig,
  GetRTOLocationByCompanyID,
  DisableUserConfig,
  GetUserConfigById,
  getCommonConfigById,
  DeleteUserConfig,
  DeleteMultipleUserConfigById,
  deleteMultipleCommonConfigById,
  deleteCommonConfigById,
  disableMultipleUserConfigById,
  saveCommonConfig,
  updateCommonConfig,
  disableCommonConfigById,
  disableMultipleCommonConfigById,
  updateCommonConfigDisableDate,
  filterRTOLocation,
};
